import {
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  CREATE_EVENT_REQUEST,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  CREATE_EVENT_BOOKING_ORDER_SUCCESS,
  CREATE_EVENT_BOOKING_ORDER_RESET,
  RESET_EVENTS_STATE,
} from "../types/event"

import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  RESET_CATEGORY_STATE,
} from '../types/category';

const initialState = {
  allPastEventList: [],
  allUpcomingEventList: [],
  activePastEventList: [],
  activeUpcomingEventList: [],
  allActiveEventList: [],
  allEventsList: [],
  eventCategoryList: [],
  bookingOrderDetails: null,
}

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENTS_SUCCESS:
      return Object.assign({}, state, {
        allPastEventList:
          action.payload.allPastList !== undefined
            ? action.payload.allPastList
            : state.allPastEventList,
        allUpcomingEventList:
          action.payload.allUpcomingList !== undefined
            ? action.payload.allUpcomingList
            : state.allUpcomingEventList,
        activePastEventList:
          action.payload.activePastList !== undefined
            ? action.payload.activePastList
            : state.activePastEventList,
        activeUpcomingEventList:
          action.payload.activeUpcomingList !== undefined
            ? action.payload.activeUpcomingList
            : state.activeUpcomingEventList,
        allActiveEventList:
          action.payload.allActiveList !== undefined
            ? action.payload.allActiveList
            : state.allActiveEventList,
        allEventsList:
          action.payload.allEvents !== undefined
            ? action.payload.allEvents
            : state.allEventsList,
      })
    case CREATE_EVENT_SUCCESS:
      return Object.assign({}, state)
    case UPDATE_EVENT_SUCCESS:
      return Object.assign({}, state)
    case DELETE_EVENT_SUCCESS:
      return Object.assign({}, state)
    case CREATE_EVENT_BOOKING_ORDER_SUCCESS:
      return Object.assign({}, state, {
        bookingOrderDetails: action.payload.data,
      })
    case CREATE_EVENT_BOOKING_ORDER_RESET:
      return Object.assign({}, state, {
        bookingOrderDetails: null,
      })
    // Reset State
    case RESET_EVENTS_STATE:
      return Object.assign({}, initialState)

    case FETCH_CATEGORIES_SUCCESS:
      return Object.assign({}, state, {
        eventCategoryList: action.payload.data,
      })

    case CREATE_CATEGORY_SUCCESS:
      return Object.assign({}, state)

    case UPDATE_CATEGORY_SUCCESS:
      return Object.assign({}, state)

    case DELETE_CATEGORY_SUCCESS:
      return Object.assign({}, state)
    case RESET_CATEGORY_STATE:
      return Object.assign({}, initialState)

    default:
      return state
  }
}

export default eventReducer
